module.exports = __webpack_public_path__ + "static/media/work5.d4832f55.jpg";